export default __webpack_public_path__ + "static/media/splitUpload.7ab67aaf.png";